// extracted by mini-css-extract-plugin
module.exports = {"parent":"Desc_parent__3jsiO","flex":"Desc_flex__3ndce"};